<template>
  <div class="space-y-3">
    <p class="text-xs text-slate-300 leading-relaxed">
      Escolha uma ou mais
      <strong class="font-semibold text-cyan-200">Caixas de e-mail (IMAP)</strong>. O agente irá monitorar essas caixas de emails conforme o agendamento.
    </p>
    <div class="rounded-lg border border-slate-600/70 bg-slate-900/35 p-3 space-y-2">
      <div class="flex items-center justify-between gap-3">
        <p class="text-sm font-medium text-slate-200">Caixas IMAP</p>
      </div>
      <div class="flex items-center gap-2">
        <select
          :value="selectedId ?? ''"
          class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 text-sm focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
          @change="onChange"
        >
          <option value="">Selecione uma caixa</option>
          <option v-for="opt in options" :key="opt.id" :value="opt.id" class="bg-slate-900">
            {{ opt.label }}
          </option>
        </select>
        <button
          type="button"
          class="whitespace-nowrap text-xs px-2 py-2 rounded border border-cyan-400/40 text-cyan-200 hover:bg-cyan-400/10"
          @click="$emit('add')"
        >
          + Adicionar
        </button>
      </div>
      <div class="flex flex-wrap gap-2">
        <span
          v-for="id in selectedIds"
          :key="`inbox-${id}`"
          class="inline-flex items-center gap-2 px-2 py-1 rounded border border-cyan-400/30 bg-cyan-400/10 text-cyan-100 text-xs"
        >
          {{ optionLabelById(options, id) || `Caixa #${id}` }}
          <button type="button" class="text-cyan-200 hover:text-white" @click="$emit('remove', id)">×</button>
        </span>
      </div>
    </div>

    <div class="rounded-md border border-slate-600/50 bg-slate-900/30 p-3 space-y-2">
      <label class="block text-xs font-medium text-slate-300">E-mails permitidos</label>
      <input
        v-model="form.settings.outputs.chat_authorized_emails"
        type="text"
        placeholder="responsavel@empresa.com; outro@empresa.com"
        class="w-full px-3 py-2 rounded-lg border border-slate-500/70 bg-slate-900/50 text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/30"
      />
      <p class="text-xs text-slate-400 leading-snug">
        No monitoramento das caixas e no chat, o agente só pode enviar e-mail para estes endereços (além do e-mail do utilizador
        logado e dos destinos do canal E-mail dos agendamentos ativos, quando configurados).
      </p>
    </div>

    <AgentExecutorSchedulesSection
      :form="form"
      specialty="email_analyst"
      :week-day-options="weekDayOptions"
      :whatsapp-delivery-connector-options="whatsappDeliveryConnectorOptions"
      hide-schedule-output-channels
    />
  </div>
</template>

<script>
import AgentExecutorSchedulesSection from './AgentExecutorSchedulesSection.vue'

export default {
  name: 'AgentSpecialtyEmailAnalystForm',
  components: { AgentExecutorSchedulesSection },
  props: {
    form: { type: Object, required: true },
    options: { type: Array, default: () => [] },
    whatsappDeliveryConnectorOptions: { type: Array, default: () => [] },
    weekDayOptions: { type: Array, default: () => [] },
    selectedId: { type: [Number, null], default: null }
  },
  emits: ['update:selectedId', 'add', 'remove'],
  computed: {
    selectedIds() {
      return Array.isArray(this.form.email_inbox_connector_ids) ? this.form.email_inbox_connector_ids : []
    }
  },
  methods: {
    optionLabelById(options, id) {
      return (options || []).find((o) => o.id === id)?.label || null
    },
    onChange(e) {
      const raw = e?.target?.value
      const parsed = raw === '' ? null : Number(raw)
      this.$emit('update:selectedId', Number.isNaN(parsed) ? null : parsed)
    }
  }
}
</script>
